export function initCardsSlider($) {
  $(".cards-slider").each(function () {
    var $section = $(this);
    var $cards = $section.find(".cards-slider_card");
    var $dots = $section.find(".cards-slider_dot");
    var $track = $section.find(".cards-slider_track");
    var total = $cards.length;
    var currentIndex = 0;
    var isAnimating = false;
  
    if (total < 2) return;
  
    // Equalize all card heights to the tallest, then size the track to match.
    // Cards are position:absolute so matchHeight() won't work — we measure manually.
    function syncHeights() {
      $cards.css("height", ""); // reset so natural content height is measured
      var maxH = 0;
      $cards.each(function () {
        var h = $(this).outerHeight();
        if (h > maxH) maxH = h;
      });
      if (maxH > 0) {
        $cards.css("height", maxH + "px");
        $track.css("height", maxH + "px");
      }
    }
  
    function updateCarousel(newIndex) {
      if (isAnimating) return;
      isAnimating = true;
  
      currentIndex = ((newIndex % total) + total) % total;
  
      $cards.each(function (i) {
        var offset = (((i - currentIndex) % total) + total) % total;
        $(this).removeClass("center up-1 up-2 down-1 down-2 hidden");
        if (offset === 0) $(this).addClass("center");
        else if (offset === 1) $(this).addClass("down-1");
        else if (offset === 2) $(this).addClass("down-2");
        else if (offset === total - 1) $(this).addClass("up-1");
        else if (offset === total - 2) $(this).addClass("up-2");
        else $(this).addClass("hidden");
      });
  
      $dots.each(function (i) {
        $(this).toggleClass("active", i === currentIndex);
      });
  
      setTimeout(function () {
        isAnimating = false;
      }, 400);
    }
  
    $cards.on("click", function () {
      if ($(this).hasClass("center")) {
        updateCarousel(currentIndex + 1);
      } else {
        updateCarousel(parseInt($(this).data("index"), 10));
      }
    });
  
    $dots.on("click", function () {
      updateCarousel(parseInt($(this).data("index"), 10));
    });
  
    // touch swipe (vertical)
    var touchStartY = 0;
    $section[0].addEventListener(
      "touchstart",
      function (e) {
        touchStartY = e.changedTouches[0].screenY;
      },
      { passive: true },
    );
    $section[0].addEventListener(
      "touchend",
      function (e) {
        var diff = touchStartY - e.changedTouches[0].screenY;
        if (Math.abs(diff) > 50) updateCarousel(currentIndex + (diff > 0 ? 1 : -1));
      },
      { passive: true },
    );
  
    syncHeights();
    updateCarousel(0);
    $(window).on("resize.cards-slider", function () {
      syncHeights();
    });
  });
}
